/* SliderComponent decides the arrow state by comparing rounded offsetLeft/clientWidth
   with scrollLeft, so on a fractional-width track the last slide never counts as
   visible and "next" stays enabled. Check the real scroll edges instead. */
if (!customElements.get('product-highlight-slider')) {
  customElements.define(
    'product-highlight-slider',
    class ProductHighlightSlider extends SliderComponent {
      update() {
        super.update();
        if (!this.slider || !this.prevButton || !this.nextButton) return;

        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        this.prevButton.disabled = this.slider.scrollLeft <= 1;
        this.nextButton.disabled = this.slider.scrollLeft >= maxScroll - 1;
      }
    }
  );
}
